module.exports = __webpack_public_path__ + "static/media/password-strength-sterk.f98a759e.svg";